import React, { useState, useEffect, useContext } from "react";
import { LuEye, LuEyeOff } from "react-icons/lu";
import '../settings.scss';
import ResetPassword from "./ResetPassword";
export const AccountDetails = ({ closePopup }) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isRestPswdVisible, setIsRestPswdVisible] = useState(false);
  const [userDetails, setUserDetails] = useState(null);

  // Toggle function for showing/hiding password
  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  const showResetPswdPopup = () => {
    setIsRestPswdVisible(true);
  }
  const hideResetPswdPopup = () => {
    setIsRestPswdVisible(false);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const userData = JSON.parse(localStorage.getItem('user'));
    setUserDetails(userData);
  };

  

  return (
    <div className="card p-3 mb-4 account-wrapper">
      <div className="d-flex gap-3 align-items-center mb-3">
        <h5 className="mb-0">Account Settings</h5>

      </div>
      <div className="row">
        <div className="col-12 col-md-3 mb-4">
          <label className="form-label" >
            User Name
          </label>
          <input type="text" className="form-control" disabled value={userDetails?.email} />

        </div>
        {/* <div className="col-12 col-md-3 mb-4">
          <label className="form-label" >
            Password
          </label>
          <div className="position-relative password-toggle ">
            <input
              type={isPasswordVisible ? "text" : "password"}
              value={'asdfgb'} disabled className="form-control ps-2"

            />
            <span
              onClick={togglePasswordVisibility}

            >
              {isPasswordVisible ? <LuEyeOff /> : <LuEye />}
            </span>
          </div>

        </div> */}
        <div className="col-md-12">
          <button
            type="submit"
            className="btn btn-primary border-curved" onClick={showResetPswdPopup}
          >
            Reset Password
          </button>

        </div>
      </div>
      {isRestPswdVisible && <ResetPassword closePopup={hideResetPswdPopup} />}


    </div>
  );
};
